<template>
  <v-card v-if="course">
    <v-card-title v-html="heading"></v-card-title>
    <v-card-actions>
      <v-icon class="close" @click="$emit('close')">$sl-close</v-icon>
    </v-card-actions>

    <v-card-text class="pb-0">
      <v-row>
        <v-col cols="6"
          ><p class="overline mt-3">Godkänd av (1)</p>
          <p class="mt-n3" v-if="get(course, 'approvedBy', null)">
            {{ course.approvedBy | fullName }}
            <span v-if="get(course, 'firstApprovedAt', null)">({{ course.firstApprovedAt | date }})</span>
          </p>
          <p class="mt-n3 grey-text font-italic" v-else>Ej godkänd.</p>
        </v-col>
        <v-col cols="6"
          ><p class="overline mt-3">Godkänd av (2)</p>
          <p class="mt-n3" v-if="get(course, 'approvedBySecondary', null)">
            {{ course.approvedBySecondary | fullName }}
            <span v-if="get(course, 'secondApprovedAt', null)">({{ course.secondApprovedAt | date }})</span>
          </p>
          <p class="mt-n3 grey-text font-italic" v-else>Ej godkänd.</p>
        </v-col>
      </v-row>
      <v-row >
        <v-col cols="10" v-if="get(course, 'status', null) === 'approved'"><p class="overline">Godkännande: Datum och utförare</p>
          <p class="mt-n3" v-if="get(course, 'firstApprovedAt', null)">
            {{ course.firstApprovedAt | date }} ({{ course.approvedBy | fullName  }})
          </p>
        </v-col>
      </v-row>
    </v-card-text>

    <v-card-actions class="justify-end">
      <v-btn color="secondary" @click="destroy()" v-if="canDestroy"> <v-icon>$sl-delete</v-icon>RADERA </v-btn>
      <v-btn @click="$emit('close')"> <v-icon>$sl-cancel</v-icon>AVBRYT </v-btn>
      <v-btn
        color="secondary"
        :disabled="!canApprove"
        @click="approve()"
      >
        <v-icon>$sl-check</v-icon>
        Godkänn
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import API from '@/services/api'
import get from 'lodash/get';
import { mapGetters } from 'vuex'

export default {
  name: 'PersonEbookSpecialCourseApprovalModal',

  props: {
    courseProp: {
      type: Object,
      default: () => ({})
    },
    visible: {
      type: Boolean,
      default: false
    }
  },

  components: {},

  watch: {
    visible: {
      handler(value) {
        if ( value ) this.getSpecialCourse()
      },
      immediate: true
    }
  },

  data:() => ({
    course: null
  }),

  computed: {
    ...mapGetters('currentuser', ['currentUser', 'currentUserRole']),

    isAdmin() {
      return get(this, 'currentUserRole', null) === 'admin'
    },

    canApprove() {
      if ( get(this, 'status', null) === 'approved' ) return false

      if ( this.isAdmin ) return true

      const approvedByCurrentUser = get(this, 'currentUser.id', null) === get(this, 'course.approvedById', null)
      const belongsToRegion = get(this, 'currentUser.regionIds', []).includes(get(this, 'course.book.regionId', null))
      return !approvedByCurrentUser && belongsToRegion
    },

    heading() {
      const courseName = get(this, 'course.courseName', 'Kursen')
      return get(this, 'status', null) === 'approved' ? `${courseName} <br /> är godkänd och klarmarkerad` : `Klarmarkera <br /> ${courseName}`
    },

    status() {
      return get(this, 'course.status', null)
    },

    canDestroy() {
      return this.isAdmin
    }
  },

  methods: {
    get,

    async getSpecialCourse() {
      try {
        if ( !get(this, 'courseProp.id', null) ) return
        const { data } = await API.getSpecialCourseApproval(this.courseProp.id)
        this.course = data
      } catch (error) {
        this.$events.fire('showError', 'Kunde inte hämta data')
      }
    },
    
    async approve() {
      try {
        const course = get(this, 'course', null)
        if ( !get(course, 'id', null) ) {
          this.$events.fire('showError', 'Ett kurs ID saknas')
          return
        }

        const res = await this.confirm(
          'Klarmarkera kurs',
          'Är du säker på att du vill klarmarkera kursen som godkänd?'
        )
        if ( res !== true ) return

        await API.completeSpecialCourseApproval(course.id)
        this.$events.fire('showInfo', 'Kursen är nu markerad som godkänd.')
        this.$emit('on-confirm')
      } catch (error) {
        console.log(error);
        this.$events.fire('showError', 'Tyvärr gick det inte att godkänna kursen.')
      }
    },

    async confirm(title = '', text = '') {
      return this.$dialog.confirm({
        title,
        text,
        actions: [
          {text: 'Avbryt', key: false, icon: '$sl-cancel'},
          {
            text: 'Ja',
            key: true,
            icon: '$sl-check',
            outlined: true
          }
        ]
      })
    },

    async destroy() {
      try {
        const course = get(this, 'course', null)
        if ( !get(course, 'id', null) ) {
          this.$events.fire('showError', 'Ett kurs ID saknas')
          return
        }

        const res = await this.confirm(
          'Ångra klarmarkering',
          'Är du säker på att du vill häva klarmarkeringen?'
        )
        if ( res !== true ) return

        await API.destroySpecialCourseApproval(course.id)
        this.$events.fire('showInfo', 'Klarmarkering borttagen')
        this.$emit('on-confirm')
      } catch (error) {
        console.log(error);
        this.$events.fire('showError', 'Tyvärr gick det inte att häva klarmarkeringen.')
      }
    }
  }
}
</script>
